import React from 'react';
import { Link } from 'react-router-dom';
import { company, contact, services } from '../../content/site';
import { socialIcons } from './Icons';

import logo from '../../images/logo-dark.png';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="site-footer__grid">
          <div className="site-footer__brand">
            <Link to="/" className="site-footer__logo" aria-label="LIDA Engineering — home">
              <img src={logo} alt="LIDA Engineering" width="173" height="44" />
            </Link>
            <p className="site-footer__tagline">{company.tagline}</p>
          </div>

          <div>
            <h2 className="site-footer__heading">Services</h2>
            <ul className="site-footer__list">
              {services.map((service) => (
                <li key={service.id}>
                  <Link to={service.link}>{service.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="site-footer__heading">Contact</h2>
            <ul className="site-footer__list">
              <li>
                <a href={contact.mapUrl} target="_blank" rel="noopener noreferrer">
                  {contact.address}
                </a>
              </li>
              <li>
                <a href={`mailto:${contact.email}`}>{contact.email}</a>
              </li>
              {contact.phones.map((phone) => (
                <li key={phone}>
                  <a href={`tel:${phone.replace(/[^+\d]/g, '')}`}>{phone}</a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="site-footer__bottom">
          <span>
            © {year} {company.legalTT}
          </span>

          <ul className="site-footer__socials">
            {contact.socials.map((social) => {
              const Icon = socialIcons[social.icon];
              return (
                <li key={social.label}>
                  <a
                    href={social.href}
                    className="social-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                  >
                    <Icon />
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
